<template>
  <CSidebar
    fixed
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand class="d-md-down-none" to="/">
      <CIcon
        class="c-sidebar-brand-full"
        :src="origin_url+'/img/nagorik_logo.png'"
        size="custom-size"
        :height="50"
        viewBox="0 0 556 134"
      />
      <CIcon
        class="c-sidebar-brand-minimized"
        :src="origin_url+'/img/nagorik_logo.png'"
        size="custom-size"
        :height="35"
      />
    </CSidebarBrand>

    <CRenderFunction flat :content-to-render="sidebarNav" />
    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    />
  </CSidebar>
</template>

<script>
import { buildFilteredNav } from "./_nav";

export default {
  name: "TheSidebar",
  data() {
    return {
      origin_url: window.location.origin
    }
  },
  computed: {
    sidebarNav() {
      // Tie to Vuex auth so the menu re-runs after login (static import-time filter used to drop items)
      const auth = this.$store.state.auth;
      auth.token;
      auth.user_permissions;
      return buildFilteredNav();
    },
    show() {
      return this.$store.state.sidebarShow;
    },
    minimize() {
      return this.$store.state.sidebarMinimize;
    }
  }
};
</script>
